import { Box, Center } from '@chakra-ui/react';
import React from 'react';

const PageLoader = () => {
    return (
        <Center h='100vh' bg={'#FFF7F7'}>
            <img src="/static/LogoVector.svg" alt="" className="pulse-logo" />
        </Center>
    )
}

export default PageLoader;